import { render, staticRenderFns } from "./Rapido.vue?vue&type=template&id=5882bda6&scoped=true"
import script from "./Rapido.vue?vue&type=script&lang=js"
export * from "./Rapido.vue?vue&type=script&lang=js"
import style0 from "./Rapido.vue?vue&type=style&index=0&id=5882bda6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5882bda6",
  null
  
)

export default component.exports